import { render, staticRenderFns } from "./ProblemCoverCol.vue?vue&type=template&id=03264b1a&scoped=true&"
import script from "./ProblemCoverCol.vue?vue&type=script&lang=js&"
export * from "./ProblemCoverCol.vue?vue&type=script&lang=js&"
import style0 from "./ProblemCoverCol.vue?vue&type=style&index=0&id=03264b1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03264b1a",
  null
  
)

export default component.exports